import { render } from "./Photos.vue?vue&type=template&id=ab0da568&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=ab0da568&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eszti-isti.donko.hu/eszti-isti.donko.hu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0da568"]])

export default __exports__